module.exports = __webpack_public_path__ + "static/media/GB.4df1e7ea.svg";